export { BusinessImage } from './BusinessImage';
